// @flow
import React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withRouter from "hoc/withRouter"
import urls from "data/router/urls"
import { formatPricing } from "data/units/money/formatters"
import { minHeightImg, selectIndexImage } from "data/images/helpers"
import type { ProductOffering } from "data/product/types"
import { Text } from "componentsStyled/Typography/Texts"
import { SubTitle } from "componentsStyled/Typography/Titles"
import { ProductTileWrap, ImageWrap, Body } from "./styled"

const ProductTile = ({ productOffering, handleClick }) => {
  const indexImage = selectIndexImage(productOffering.images)
  const imageSize = minHeightImg(indexImage, 250)

  return (
    <ProductTileWrap onClick={handleClick}>
      <ImageWrap>
        <img src={imageSize.url} alt={indexImage.alt} draggable="false" />
      </ImageWrap>
      <Body>
        <Text small>{productOffering.manufacturer.name}</Text>
        <SubTitle>{productOffering.name}</SubTitle>
        <Text small>
          <Text small inline black book>
            {formatPricing(
              productOffering.pricingDetails.prices,
              productOffering.currency,
            )}
          </Text>{" "}
          per day
        </Text>
        <Text small>{productOffering.affiliateName}</Text>
      </Body>
    </ProductTileWrap>
  )
}

type Outter = {|
  productOffering: ProductOffering,
|}

const enhancer: HOC<*, Outter> = compose(
  withRouter,
  withHandlers({
    handleClick: props => () => {
      props.history.push(
        urls.product(props.productOffering.productId, props.productOffering.affiliateId),
      )
    },
  }),
)

export default enhancer(ProductTile)



// WEBPACK FOOTER //
// ./src/components/ProductList/ProductTile/index.js